//Generated File 
export const APICredentials = `APICredentials`;
export const AccountingCalendar = `AccountingCalendar`;
export const AccountingSideConfig = `AccountingSideConfig`;
export const AccountsBag = `AccountsBag`;
export const AdditionalCost = `AdditionalCost`;
export const AddressRegion = `AddressRegion`;
export const ApprovalDefinition = `ApprovalDefinition`;
export const ApprovalReason = `ApprovalReason`;
export const BudgetScenario = `BudgetScenario`;
export const BulkMessage = `BulkMessage`;
export const Car = `Car`;
export const CarBrand = `CarBrand`;
export const CarModel = `CarModel`;
export const ConfigEntry = `ConfigEntry`;
export const ConfigGroup = `ConfigGroup`;
export const Contact = `Contact`;
export const CriteriaBasedValidator = `CriteriaBasedValidator`;
export const CriteriaDefinition = `CriteriaDefinition`;
export const Currency = `Currency`;
export const CustomListView = `CustomListView`;
export const CustomReportMenu = `CustomReportMenu`;
export const Customer = `Customer`;
export const CustomerCategory = `CustomerCategory`;
export const CustomerClass = `CustomerClass`;
export const CustomerClass1 = `CustomerClass1`;
export const CustomerClass2 = `CustomerClass2`;
export const CustomerClass3 = `CustomerClass3`;
export const CustomerClass4 = `CustomerClass4`;
export const CustomerClass5 = `CustomerClass5`;
export const DLVDeliveryArea = `DLVDeliveryArea`;
export const DLVDeliveryConfig = `DLVDeliveryConfig`;
export const DLVDeliveryDocument = `DLVDeliveryDocument`;
export const DLVDeliveryPlan = `DLVDeliveryPlan`;
export const DLVDeliveryReturn = `DLVDeliveryReturn`;
export const DLVDriverCarAreaAssignment = `DLVDriverCarAreaAssignment`;
export const DMSCompressedFileToDocs = `DMSCompressedFileToDocs`;
export const DMSDocMovement = `DMSDocMovement`;
export const DMSDocument = `DMSDocument`;
export const DMSFolder = `DMSFolder`;
export const DMSFolderMovement = `DMSFolderMovement`;
export const DMSLocation = `DMSLocation`;
export const DMSTopic = `DMSTopic`;
export const DashBoard = `DashBoard`;
export const DashBoardGroup = `DashBoardGroup`;
export const DashBoardWidget = `DashBoardWidget`;
export const DashBoardWidgetWizard = `DashBoardWidgetWizard`;
export const DataSource = `DataSource`;
export const DatabaseCleaner = `DatabaseCleaner`;
export const DatesOverrider = `DatesOverrider`;
export const DefaultValuesTemplate = `DefaultValuesTemplate`;
export const Delegation = `Delegation`;
export const DeliveryCar = `DeliveryCar`;
export const DepartmentSection = `DepartmentSection`;
export const DetailedRemark = `DetailedRemark`;
export const DiscountCoupon = `DiscountCoupon`;
export const DiscountCouponBook = `DiscountCouponBook`;
export const DiscountCouponType = `DiscountCouponType`;
export const DocCategory = `DocCategory`;
export const DocumentCancelDocument = `DocumentCancelDocument`;
export const EInvoiceNotificationReceiver = `EInvoiceNotificationReceiver`;
export const EmpWorkPlace = `EmpWorkPlace`;
export const Employee = `Employee`;
export const EmployeeAgenda = `EmployeeAgenda`;
export const EmployeeDepartment = `EmployeeDepartment`;
export const EmployeeGroup = `EmployeeGroup`;
export const EntityFlow = `EntityFlow`;
export const EntityHelp = `EntityHelp`;
export const EntityTypeList = `EntityTypeList`;
export const ErrorMessage = `ErrorMessage`;
export const ExchangeRate = `ExchangeRate`;
export const FeatureSet = `FeatureSet`;
export const FieldFiltering = `FieldFiltering`;
export const FilesExportMenu = `FilesExportMenu`;
export const FiscalPeriod = `FiscalPeriod`;
export const FiscalYear = `FiscalYear`;
export const FormDoc1 = `FormDoc1`;
export const FormDoc10 = `FormDoc10`;
export const FormDoc2 = `FormDoc2`;
export const FormDoc3 = `FormDoc3`;
export const FormDoc4 = `FormDoc4`;
export const FormDoc5 = `FormDoc5`;
export const FormDoc6 = `FormDoc6`;
export const FormDoc7 = `FormDoc7`;
export const FormDoc8 = `FormDoc8`;
export const FormDoc9 = `FormDoc9`;
export const FreezeProcessingDoc = `FreezeProcessingDoc`;
export const FreightLine = `FreightLine`;
export const GUIPostActions = `GUIPostActions`;
export const GUITheme = `GUITheme`;
export const GenericReferenceOverrider = `GenericReferenceOverrider`;
export const GoPayAccount = `GoPayAccount`;
export const GoPayConfiguration = `GoPayConfiguration`;
export const HRExperience = `HRExperience`;
export const HRInsurancePolicy = `HRInsurancePolicy`;
export const HRSkill = `HRSkill`;
export const HijriTable = `HijriTable`;
export const ImplementationRepository = `ImplementationRepository`;
export const JobPosition = `JobPosition`;
export const KeyWordFile = `KeyWordFile`;
export const KeyWordValue = `KeyWordValue`;
export const KeywordTemplate = `KeywordTemplate`;
export const LegalLicense = `LegalLicense`;
export const LimitUserToYear = `LimitUserToYear`;
export const MeetingRemark = `MeetingRemark`;
export const MenuDefinition = `MenuDefinition`;
export const MenuModifier = `MenuModifier`;
export const MobileAppAction = `MobileAppAction`;
export const MobileAppDashboard = `MobileAppDashboard`;
export const MobileAppFieldsSearcherContext = `MobileAppFieldsSearcherContext`;
export const MobileAppMenuDefinition = `MobileAppMenuDefinition`;
export const MobileAppScreenModifier = `MobileAppScreenModifier`;
export const MobileAppShortcut = `MobileAppShortcut`;
export const MobileAppTranslationOverride = `MobileAppTranslationOverride`;
export const MobileEntityTitleModifier = `MobileEntityTitleModifier`;
export const ModifyCustomerInfoReq = `ModifyCustomerInfoReq`;
export const ModifySupplierInfoReq = `ModifySupplierInfoReq`;
export const MultiValueReportParameter = `MultiValueReportParameter`;
export const Nationality = `Nationality`;
export const NotificationDefinition = `NotificationDefinition`;
export const OAuthFile = `OAuthFile`;
export const OnlinePaymentConfig = `OnlinePaymentConfig`;
export const OrganizationPosition = `OrganizationPosition`;
export const PGWMethodGroup = `PGWMethodGroup`;
export const PartnerShares = `PartnerShares`;
export const PaymentFromPosSettings = `PaymentFromPosSettings`;
export const PaymentLinksCreationDoc = `PaymentLinksCreationDoc`;
export const PaymentMethod = `PaymentMethod`;
export const PaymentScheduleTemplate = `PaymentScheduleTemplate`;
export const PaymentTerminal = `PaymentTerminal`;
export const PerformanceOptimizer = `PerformanceOptimizer`;
export const PrintingFormWizard = `PrintingFormWizard`;
export const PurgeConfig = `PurgeConfig`;
export const ReceiptBook = `ReceiptBook`;
export const ReceiptPaper = `ReceiptPaper`;
export const RecordImportConfig = `RecordImportConfig`;
export const RecordImportDoc = `RecordImportDoc`;
export const RecordImportList = `RecordImportList`;
export const RecuringDocument = `RecuringDocument`;
export const Remark = `Remark`;
export const RemarkType = `RemarkType`;
export const RemarkType2 = `RemarkType2`;
export const RemarkType3 = `RemarkType3`;
export const RemarkType4 = `RemarkType4`;
export const RemarkType5 = `RemarkType5`;
export const ReplicationSite = `ReplicationSite`;
export const ReportDefinition = `ReportDefinition`;
export const ReportGroup = `ReportGroup`;
export const ReportStyle = `ReportStyle`;
export const ReportWizard = `ReportWizard`;
export const RequiredFields = `RequiredFields`;
export const Responsibility = `Responsibility`;
export const ReverseRedeemAmountDoc = `ReverseRedeemAmountDoc`;
export const RevisionDoc = `RevisionDoc`;
export const RewardPointCalculatorConfig = `RewardPointCalculatorConfig`;
export const RewardPointsConfig = `RewardPointsConfig`;
export const RewardPointsOpening = `RewardPointsOpening`;
export const SafeDeposite = `SafeDeposite`;
export const SalesPriceClassifier1 = `SalesPriceClassifier1`;
export const SalesPriceClassifier2 = `SalesPriceClassifier2`;
export const SalesPriceClassifier3 = `SalesPriceClassifier3`;
export const SalesPriceClassifier4 = `SalesPriceClassifier4`;
export const SalesPriceClassifier5 = `SalesPriceClassifier5`;
export const SalesStandardTerm = `SalesStandardTerm`;
export const ScreenModifier = `ScreenModifier`;
export const SecurityCapability = `SecurityCapability`;
export const SecurityProfile = `SecurityProfile`;
export const SecurityProfileTransfer = `SecurityProfileTransfer`;
export const ShippingPort = `ShippingPort`;
export const ShoppingMobAppConfig = `ShoppingMobAppConfig`;
export const ShortCutsDefinition = `ShortCutsDefinition`;
export const SpecialResponsible = `SpecialResponsible`;
export const Sponsor = `Sponsor`;
export const StandardTermExtension = `StandardTermExtension`;
export const StandardTermFulfillment = `StandardTermFulfillment`;
export const Subsidiary1 = `Subsidiary1`;
export const Subsidiary2 = `Subsidiary2`;
export const Subsidiary3 = `Subsidiary3`;
export const Subsidiary4 = `Subsidiary4`;
export const Subsidiary5 = `Subsidiary5`;
export const SubsidiaryClass = `SubsidiaryClass`;
export const Supplier = `Supplier`;
export const SupplierClass = `SupplierClass`;
export const TaskSchedule = `TaskSchedule`;
export const TaxAuthoritySubmissionDoc = `TaxAuthoritySubmissionDoc`;
export const TaxDiscountEffectsConfig = `TaxDiscountEffectsConfig`;
export const TaxPayerConfiguration = `TaxPayerConfiguration`;
export const TaxPlan = `TaxPlan`;
export const ThirdParty = `ThirdParty`;
export const TooltipDefinition = `TooltipDefinition`;
export const TranslationOverRider = `TranslationOverRider`;
export const UpdateCustomerInfo = `UpdateCustomerInfo`;
export const UserAddRequest = `UserAddRequest`;
export const UserFavourites = `UserFavourites`;
export const UserFieldFilter = `UserFieldFilter`;
export const UserMobileIdentifierDocument = `UserMobileIdentifierDocument`;
export const UserTimedQuery = `UserTimedQuery`;
export const UsersCounter = `UsersCounter`;
export const WhatsAppMessage = `WhatsAppMessage`;
export const WhatsAppMessageConfiguration = `WhatsAppMessageConfiguration`;
export const WizardFile = `WizardFile`;
export const WorkTask = `WorkTask`;
export const WorkTaskCategory = `WorkTaskCategory`;
